import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Text,
  UnorderedList,
  ListItem,
  VStack,
  Divider,
} from '@chakra-ui/react';

const ReviseVersion = ({ versionData }) => {
  const { title, content, comment, feedbackTasks } = versionData;
  const contentParagraphs = content
    .split('\n')
    .filter((paragraph) => paragraph.trim() !== '');

  return (
    <Box
      border="1px solid"
      borderColor="gray.200"
      borderRadius="md"
      p={3}
      maxHeight="400px" // Limit the height of the component
      overflowY="auto" // Enable scroll bar when content exceeds the height
    >
      <Text
        fontSize="md"
        fontWeight="bold"
        align="center"
        color="gray.700"
        mb={2}
      >
        {title}
      </Text>

      <VStack align="start" spacing={4}>
        <Box>
          {contentParagraphs.map((paragraph, index) => (
            <Text fontSize="md" color="gray.700" mb={1} key={index}>
              {paragraph}
            </Text>
          ))}
        </Box>

        <Divider />
        <Box>
          <Text fontSize="md" fontWeight="bold" color="teal.700" mb={2}>
            Comment:
          </Text>
          <Text fontSize="md" color="gray.600">
            {comment}
          </Text>
        </Box>

        <Divider />
        <Box>
          <Text fontSize="md" fontWeight="bold" color="teal.700" mb={2}>
            Feedback Tasks:
          </Text>
          <UnorderedList pl={5}>
            {feedbackTasks.map((task, index) => (
              <ListItem key={index} fontSize="md" color="gray.600">
                {task.task}
              </ListItem>
            ))}
          </UnorderedList>
        </Box>
      </VStack>
    </Box>
  );
};

ReviseVersion.propTypes = {
  versionData: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  ),
};

export default ReviseVersion;
